
































import { Component, Prop, Vue } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import FogetPasswordForm from "./components/fogetPasswordForm.vue";
const a = namespace("a");
@Component({ components: { FogetPasswordForm } })
export default class ForgetPassword extends Vue {
  created() {
    sessionStorage.setItem("accessLogin", "1");
  }
  goLogin() {
    this.$router.push({
      name: "Login"
    });
  }
}
